/**
 * Lightweight cookie consent reads — shared without circular imports.
 */

const defaultPreferences = {
  essential: true,
  analytics: false,
  functional: false,
  targeting: false,
};

export function getCookiePreferences() {
  try {
    const consentGiven = localStorage.getItem('cookieConsent');
    if (!consentGiven) {
      return { ...defaultPreferences };
    }

    const preferences = JSON.parse(localStorage.getItem('cookiePreferences'));
    if (!preferences) {
      return { ...defaultPreferences };
    }

    return {
      ...defaultPreferences,
      ...preferences,
      essential: true,
    };
  } catch {
    return { ...defaultPreferences };
  }
}

export function isCookieAccepted(type) {
  if (type === 'essential') return true;
  const preferences = getCookiePreferences();
  return preferences[type] === true;
}
